import React, { useEffect } from 'react';
import './pagination.css';

export const Pagination = (props) => {
    const { totalCount, onPaginationButtonClick, allOffersData, page, itemsPerPage } = props;
    const totalPages = Math.ceil(allOffersData?.length / itemsPerPage);

    const reset = localStorage.getItem("changing")
    
    const onNextButtonClick = () => {
        localStorage.removeItem("changing")
        onPaginationButtonClick(page + 1)
    }
    
    const onPreviousButtonClick = () => {
        localStorage.removeItem("changing")
        window.scrollTo(0, 0);
        onPaginationButtonClick(page - 1)
    }
    
    const onPageNumberClick = (pageNumber) => {
        localStorage.removeItem("changing")
        window.scrollTo(0, 0);
        onPaginationButtonClick(pageNumber)
    }
    
    const resetState = () => {
        // Reset state logic here
    }
    
    useEffect(() => {
        resetState()
    }, [reset])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [totalCount])

    // Generate page numbers to display
    const getPageNumbers = () => {
        const pages = [];
        
        if (totalPages <= 5) {
            // Show all pages if 5 or fewer
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            // Show 5 pages around current page
            let start = Math.max(1, page - 2);
            let end = Math.min(totalPages, start + 4);
            
            // Adjust start if we're near the end
            if (end - start < 4) {
                start = Math.max(1, end - 4);
            }
            
            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
        }
        
        return pages;
    }

    const pageNumbers = getPageNumbers();

    // Debug logging
    console.log('Total pages:', totalPages);
    console.log('Page numbers:', pageNumbers);
    console.log('Current page:', page);
    console.log('AllOffersData length:', allOffersData?.length);
    console.log('Items per page:', itemsPerPage);

    // Early return if no data
    if (!allOffersData || allOffersData.length === 0 || totalPages === 0) {
        console.log('No data to paginate');
        return null;
    }

    return (
        <div className='pagination-section'>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {/* Show prev button only if more than 5 pages */}
                {totalPages > 1 && (
                    <button 
                        className="prev" 
                        disabled={page === 1} 
                        onClick={() => onPreviousButtonClick()}
                    >
                        {'prev'}
                    </button>
                )}
                
                {/* Show page numbers */}
                {pageNumbers.map((pageNumber) => (
                    <button
                        key={pageNumber}
                        className={`page-number ${page === pageNumber ? 'active' : ''}`}
                        onClick={() => onPageNumberClick(pageNumber)}
                      
                    >
                        {pageNumber}
                    </button>
                ))}
                
                {/* Show next button only if more than 5 pages */}
                {totalPages > 1 && (
                    <button 
                        className="next" 
                        disabled={page === totalPages} 
                        onClick={() => onNextButtonClick()}
                    >
                        {'next'}
                    </button>
                )}
            </div>
        </div>
    )
}